import React, { ReactElement } from 'react'

const Divider = (): ReactElement => {
    return <div className="divider" />
}

export default Divider
